










































































































































































































































import { Component, Vue, Provide } from "vue-property-decorator";
import { getOrderOptions } from "@/request/ticketClientRequest";
import { timeFormat, downloadFile } from "@/utils/index";
import { pagnition } from "@/utils/commonConfig";
import { LoanTypeEnum } from "@/enum/index";
import { ticketClient } from "@/api/index";
import { GetTicketListParamReq } from "@/pbjs/xcommon/ticket_pb";
import { setCommon, errorMsg } from "@/utils/request";
@Component({
  name: "PerformanceManagement2",
  components: {},
})
export default class PerformanceManagement2 extends Vue {
  @Provide() private country: any = localStorage.getItem("country"); // 国家，字段差异化展示
  @Provide() private orderOptions: any = []; // lee 工单分类下拉列表
  @Provide() private searchForm: any = {
    ItemId: "",
    Email: "",
    UserGroup: "",
    Loantype: "",
    UserName: "",
    employeeID: "",
    TimeRange: [],
  }; // lee 搜索表单
  @Provide() private RangeType: number = -1; // StatsType: 1=按小时, 2=按天, 3=按小时汇总, 4=按天汇总
  @Provide() private labelPosition: string = "right"; // // by Hour: 1  or by Day: 0;
  @Provide() private pickerOptions: any = {
    onPick: (opt: any) => {
    },
    shortcuts: [
      {
        text: "Today",
        onClick(picker: any) {
          const start = new Date();
          const _starttime =
            start.getFullYear() +
            "-" +
            (start.getMonth() + 1) +
            "-" +
            start.getDate();
          start.setTime(new Date(_starttime).getTime());
          const end = new Date();
          end.setTime(end.getTime());
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "Yesterday",
        onClick(picker: any) {
          const end = new Date();
          const _endtime =
            end.getFullYear() +
            "-" +
            (end.getMonth() + 1) +
            "-" +
            end.getDate();
          end.setTime(new Date(_endtime).getTime());
          const start = new Date();
          start.setTime(new Date(_endtime).getTime() - 24 * 60 * 60 * 1000);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "Last 7 days",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        },
      },
    ],
    start: "00:00",
    step: "00:10",
    end: "23: 50",
  };
  @Provide() private AppName: any = []; // 项目名称
  @Provide() private pickDate: any = ""; // 时间范围
  @Provide() private updatedTime: any = ""; // 上次更新时间
  @Provide() private totalstats: any = ""; // 上次更新时间
  @Provide() private pickedHour: any = ""; // 上次更新时间
  @Provide() private pickTime: any = ""; // 小时
  
  @Provide() private statssort: any = ""; // 按xx排序
  @Provide() private pickTimeOptions: any = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
  ];
  @Provide() private isHoured: boolean = false; // 是否显示小时
  @Provide() private resultData: any = [];
  @Provide() private ExtNumber: any = "";
  @Provide() private token: any = "";
  @Provide() private userid: any = "";
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0; // lee 分页参数 目前分页是自己处理的
  @Provide() private rank: number = 2;
  @Provide() private AppOpnList: any = [];
  // lee 升降序 1升2降
  // 20200819 有一个兆麟的傻子要求默认成2
  @Provide() private MorkResultData: any = [
    {
      Id: 1111,
      ExtNumber: 1111,
      Utime: 1111,
      Supplier: 1111,
    },
  ];
  @Provide() private isMorked: boolean = false; // lee 模拟数据
  @Provide() private isDateButton: boolean = false;
  @Provide() private isSearchFormActionDone: boolean = false;
  @Provide() private pagnition: any = pagnition;
  @Provide() private isKe: any = false; // 是否为肯尼亚国家
  @Provide() private isCompletedOption: Array<Object> = [
    // 0: 全部, 1:已完成,2:未完成
    { label: "ticketLgy.All", value: 0 },
    { label: "performance.completed", value: 1 },
    { label: "performance.inCompleted", value: 2 },
  ];
  @Provide() private LoanTypeEnumOptions: any = Reflect.ownKeys(LoanTypeEnum)
    .slice(1)
    .map((item: any, index: number) => {
      let obj: any = {};
      switch (item) {
        case "LOAN_TYPE_FIRST":
          obj.name = "v0707.FirstLoan";
          break;
        case "LOAN_TYPE_REPEAT":
          obj.name = "v0707.Reloan";
          break;
        case "LOAN_TYPE_ALL":
          obj.name = "ticketLgy.All";
          break;
      }
      obj.value = index + 1;
      return obj;
    });
  get roleData(): any {
    return this.$store.getters.ROLE_INFO;
  } //  角色
  get appNameParam(): string {
    return Array.isArray(this.AppName)
      ? this.AppName.join(",")
      : String(this.AppName || "");
  }
  private created() {
    this.token = localStorage.getItem("token");
    this.userid = localStorage.getItem("userid");
    this.getOrderOptions();
    // this.getExtenList(); // 获取列表数据
    this.getCurrentCountry();
    //获取appname列表
    this.getTicketListParam()
  }
  private getCurrentCountry() {
    // 获取当前系统国家
    const country = localStorage.getItem("country");
    this.isKe = country === "ke" || false;
  }
  //  处理 日期时间选择操作
  private pickerAction(val) {
    if (!this.pickDate || !this.pickDate.length) {
      this.isHoured = false;
      this.pickTime = "";
      return;
    }
    const startDate = new Date(this.pickDate[0]);
    const endDate = new Date(this.pickDate[1]);
    const startDay = new Date(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate()
    ).getTime();
    const endDay = new Date(
      endDate.getFullYear(),
      endDate.getMonth(),
      endDate.getDate()
    ).getTime();
    if (startDay === endDay) {
      this.isHoured = true;
      let _now = new Date();
      let _nowTimeStamp = new Date(
        _now.getFullYear(),
        _now.getMonth(),
        _now.getDate()
      ).getTime();
      // 默认展示当前的小时，向上取整；如果不是当天展示23
      if (startDay === _nowTimeStamp) {
        const nextHour = Math.min(_now.getHours() + 1, 24);
        this.pickTime = nextHour < 10 ? `0${nextHour}` : `${nextHour}`;
      } else {
        this.pickTime = "24";
      }
    } else {
      this.isHoured = false;
      this.pickTime = "";
    }
  }
  private chearFuc(evt: any) {
  }
  private pickerBlurAction() {
  }
  private addButton() {
    this.isDateButton = true;
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getExtenList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getExtenList();
  }

  private timeFormatFunc(val) {
    return timeFormat(val)
  }
  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getExtenList();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getExtenList();
  }
  // 获取工单分类下拉列表
  private async getOrderOptions() {
    let res: any = await getOrderOptions({
      token: this.token,
    });
    switch (res.status) {
      case "success":
        this.orderOptions = res.data;
        break;
      case "code":
        this.$router.push("./login");
        break;
      case "error":
        this.$message.error(res.message);
        break;
    }
  }

  // lee 搜索操作的判断
  private testSearchForm(): boolean {
    if (this.pickDate && this.pickDate.length > 0) {
      if (this.isHoured && !this.pickTime) {
        this.$message.error("Please choose the time");
        return false;
      }
      return true;
    } else {
      this.$message.error("Please choose the time");
      return false;
    }
  }
  // StatsType: 1=按小时, 2=按天, 3=按小时汇总, 4=按天汇总
  private searchFormActionByTime(num: number) {
    this.RangeType = num;
    this.pageIndex = 1;
    if (this.testSearchForm()) {
      this.getExtenList();
    }
  }
  //查询
  private searchFormAction() {
    if (this.testSearchForm()) {
      this.isSearchFormActionDone = true;
      this.pageIndex = 1;
      if (this.isHoured) {
        this.RangeType = 3;
      } else {
        this.RangeType = 4;
      }
      this.getExtenList();
    }
  }
  //  lee 清除操作
  private clearFormAction() {
    (this.$refs["searchForm"] as any).resetFields();
    this.$store.dispatch("storeRole", {
      id: 0,
      name: "",
    });
    this.searchForm.TimeRange = "";
    this.pickDate = "";
    this.pickTime = "";
    this.statssort = "";
    this.rank = 2;
    this.RangeType = -1;
  }
  //  lee 排序操作
  //  默认升序，翻页或者搜索置为默认
  private orderFormAction() {
    if (this.testSearchForm()) {
      this.pageIndex = 1;
      this.getExtenList();
    }
  }
  //  lee 清除操作
  private refreshFormAction() {
    if (this.testSearchForm()) {
      this.pageIndex = 1;
      this.getExtenList();
    } else {
      this.$message.warning("Pls enter the right params!!");
    }
  }
  //  lee 导出操作
  private async exportFormAction() {
    if (!this.testSearchForm()) {
      return;
    }
    const _arg = this.buildQueryArgs();

    const { getHourlyCollectionStatsExcel }: any = await import(
      "@/request/getHourlyCollectionStats"
    );
    let response = await getHourlyCollectionStatsExcel(_arg, this);
    if (response) {
      if (response?.array[3]?.length > 0) {
        const blob = new Blob([response.array[3]], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        downloadFile(blob, response.array[2]);
      }else {
        this.$message.error(response.toObject().commonout.errmsg);
      }
    }
  }
  private isNull(val: any): boolean {
    if (val) {
      return false;
    }
    return true;
  }
  private sortChange(val: any) {
    if (!val.order) {
      this.statssort = "";
      this.rank = 2;
      this.getExtenList();
      return;
    }
    this.statssort = "";
    switch (val.prop) {
      case "loadleftunpaidprincipal":
        this.statssort = 6;
        break;
      case "repaytotal":
        this.statssort = 9;
        break;
      case "repayamountrate":
        this.statssort = 11;
        break;
      case "targetrepayrate":
        this.statssort = 12;
        break;
      case "diffrepayamountrate":
        this.statssort = 0;
        break;
      case "avghandlenum":
        this.statssort = 13;
        break;
      case "diffavghandlenum":
        this.statssort = 0;
        break;
      case "completerate":
        this.statssort = 14;
        break;
    }
    switch (val.order) {
      case "descending":
        this.rank = 2;
        break;
      case "ascending":
        this.rank = 1;
        break;
      default:
        this.rank = 2;
        break;
    }
    this.getExtenList();
  }
  private hasValue(val: any): boolean {
    return val !== undefined && val !== null && val !== "";
  }
  private buildQueryArgs() {
    if (this.RangeType < 0) {
      this.RangeType = this.isHoured ? 3 : 4;
    }
    const _arg: any = {
      ItemId: Number(this.searchForm.ItemId) || 0, // 工单分类
      Statstype: Number(this.RangeType),
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      sort: "",
      Statssort: Number(this.statssort) || 0,
      rank: this.rank, // 1 顺序，2 倒叙
      AppName: this.appNameParam,
      Timerange: "",
    };
    if (this.RangeType === 3 || this.RangeType === 1) {
      _arg.Hour = Number(this.pickTime);
    }
    if (this.hasValue(this.searchForm.Loantype)) {
      _arg.Loantype = Number(this.searchForm.Loantype);
    }
    if (this.pickDate && this.pickDate.length > 0) {
      _arg.Timerange =
        timeFormat(this.pickDate[0].getTime()) +
        " - " +
        timeFormat(this.pickDate[1].getTime());
    }
    return _arg;
  }
  getTicketListParam() {
    let request: any = new GetTicketListParamReq();
    request.setCommonin(setCommon());
    ticketClient.getPsTicketListParam(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        this.AppOpnList = JSON.parse(data.applist)

      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  // 获取列表
  private async getExtenList() {
    const _arg = this.buildQueryArgs();
    const { getHourlyCollectionStatsReq }: any = await import(
      "@/request/getHourlyCollectionStats"
    );
    let res = await getHourlyCollectionStatsReq(_arg, this);
    if (res) {
      let _result =
        typeof res.listList == "object"
          ? res.listList
          : JSON.parse(res.listList);
      this.pagerCount = res.pageout ? res.pageout.total : 0;
      this.updatedTime = timeFormat(res.updatetime);
      if (res.totalstats) {
        this.totalstats = res.totalstats;
      }
      if (_result) {
        // lee 接口数据通了，但是没有数据，暂时Mork一份
        this.resultData = this.isMorked ? this.MorkResultData : _result;
      }
    }
    this.isSearchFormActionDone = res ? res.loading : false;
  }
  private changeAppName() {

  }
  private fixLastTime(time) {
    if(!time) {
      return 0
    }
    // {{scope.row.lasthandletime ? ((new Date().getTime() - new Date(scope.row.lasthandletime).getTime())/1000/60/60).toFixed(1): 0}} {{$t('ticket.Hour')}}
    let startTime = new Date(time).getTime(); // 开始时间
    let endTime = new Date().getTime(); // 结束时间
    let usedTime = endTime - startTime; // 相差的毫秒数
    let days = Math.floor(usedTime / (24 * 3600 * 1000)); // 计算出天数
    let leavel = usedTime % (24 * 3600 * 1000); // 计算天数后剩余的时间
    let hours = Math.floor(leavel / (3600 * 1000)); // 计算剩余的小时数
    let leavel2 = leavel % (3600 * 1000); // 计算剩余小时后剩余的毫秒数
    let minutes = Math.floor(leavel2 / (60 * 1000)); // 计算剩余的分钟数
    return (days *24*60 + hours*60 + minutes) + ' '+ this.$t('ticket.MIN');
  }
}
